import React from 'react'

const Footer = () => (
  <p>
    Created by Dominic Pace using React, JavaScript and custom CSS. Check out the repo <a href='https://github.com/Dominic-Pace/dp-app' rel='noopener noreferrer' target='_blank'>HERE</a> on github © {(new Date()).getFullYear()}
  </p>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/index.js